import router from '@/router';
import axios from 'axios';
import storage from '../utils/storage';

const ERROR_MESSAGES = {
  INTERNAL_SERVER_ERROR: 'Ops... Tivemos um problema no servidor.\n Por favor, tente novamente em alguns instantes :)',
};

const BACKEND_API = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API,
});

BACKEND_API?.interceptors?.request?.use((request) => {
  const token = storage.get('token');
  if (token) request.headers.Authorization = `Bearer ${token}`;
  return request;
});

async function resolvePromise(promise) {
  return promise
    .then((response) => response.data)
    .catch((error) => {
      switch (error?.response?.status) {
        case 500:
          throw Error(ERROR_MESSAGES.INTERNAL_SERVER_ERROR);
        case 401:
          router.push('/logout');
          break;
        case 400:
          throw Error(error?.response?.data?.message);
        default:
          throw error;
      }
    });
}

export default {
  // AUTH
  auth(code) {
    const token = BACKEND_API.post(`/auth/token?code=${code}`);
    return token;
  },
  async loginWebsocket() {
    const result = await BACKEND_API.post(`/auth/frontend/websocket-token`).then((response) => response.data);

    return result?.accessToken;
  },
  getUserLogged() {
    return BACKEND_API.get(`/users/logged`);
  },

  // USER
  createUser(user) {
    const promise = BACKEND_API.post(`/users`, user);
    return resolvePromise(promise);
  },
  getUsers() {
    const promise = BACKEND_API.get(`/users`);
    return resolvePromise(promise);
  },
  deleteUser(userId) {
    const promise = BACKEND_API.delete(`/users/${userId}`);
    return resolvePromise(promise);
  },

  getTotalFolders() {
    const promise = BACKEND_API.get('/folders/total');
    return resolvePromise(promise);
  },

  deleteFolder(id) {
    const promise = BACKEND_API.delete(`/folders/${id}`);
    return resolvePromise(promise);
  },

  createFolder(folder) {
    const promise = BACKEND_API.post(`/folders`, {
      ...this.makeFolderDTO(folder),
    });
    return resolvePromise(promise);
  },

  editFolder(folder) {
    const promise = BACKEND_API.put(`/folders/${folder.id}`, {
      ...this.makeFolderDTO(folder),
      isActive: folder.isActive,
    });
    return resolvePromise(promise);
  },

  makeFolderDTO(folder) {
    const dto = {
      name: folder.name,
      folderName: folder.folderName,
      placeName: folder.placeName,
      clientProvider: folder.clientProvider,
      sagaId: folder.sagaId,
      drEnabled: folder.drEnabled,
      programStartTime: folder.programStartTime || undefined,
    };

    if (folder.clientProvider === 0) {
      dto.sagaId = null;
    }

    return dto;
  },

  formSync(folderId) {
    const promise = BACKEND_API.put(`/folders/${folderId}/forms/sync`);
    return resolvePromise(promise);
  },

  updateFolderAddStorage(id, params) {
    const promise = BACKEND_API.put(`/folders/${id}/storage/config`, params);
    return resolvePromise(promise);
  },
};
